import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=55edbd16&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edbd16",
  null
  
)

export default component.exports